import React from 'react';
import { Modal, Typography } from 'antd';
import { ConfigProvider } from 'antd';
import { COLORS } from '../../../themes/colors';
import '../modal.scss';

const { Paragraph } = Typography;
const RetrySavingModal: React.FC<{
  isOpen: boolean;
  handleCancel: () => void;
  handleRetry: () => void;
}> = ({ isOpen, handleRetry, handleCancel }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: COLORS.cipherGreenL0,
        },
      }}
    >
      <Modal
        closable={false}
        className="modal"
        title="Saving failed"
        okText="Retry"
        onOk={handleRetry}
        onCancel={handleCancel}
        cancelText="Cancel"
        open={isOpen}
      >
        <Paragraph data-cy="modal_retry_body">
          We encountered a problem while trying to save your last answer. Click
          Retry to resubmit your answer.
        </Paragraph>
      </Modal>
    </ConfigProvider>
  );
};

export default RetrySavingModal;
